<template>
  <el-container>
    <el-main><main-content :homeData2="homeData"></main-content></el-main>
  </el-container>
</template>

<script>
  // import Bus from "@/components/layout/bus"
  // import navMenu from '@/components/layout/navMenu'
  import mainContent from '@/components/layout/mainContent'
  // import memberMenu from '@/components/layout/memberMenu'
  import {myPost,myGet} from '@/api/http'
  export default { 
    components: {mainContent},
    data() {
      return {
        siteList: [],
        homeData:{}
      }
    },
    created() {
      // this.getSiteList()
      
    },
    mounted() {
      // this.loginSite()
    },
    // updated() {
    //   Bus.$emit("msg" , this.homeData);
    // },
    computed: {
      changeStyle2() {
        return {
          'position': 'relative',
          'left': this.$store.state.leftStyle - this.$store.state.distance + "px",
          'top': '0px',
          'padding-top': '13px',
          'display': this.$store.state.displayFlag,
          'margin': '0 auto',
        }
      }
    },
    methods: {
      navClick2(parentUrl, item) {
        // 如果此栏目属于跳转栏目的话就使用url作为跳转链接
        if (item.sectionType === "REDIRECT" && item.url !== null) {
          var reg=/(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/;
          // 如果不是一个网址 就正常跳转路由
          if (!reg.test(item.url)) {
            this.$router.push(`/${item.url}`)
            // 如果是一个网址 就跳转这个网址
          } else {
            window.location.href = item.url
          }
          // 如果此栏目不属于的话就自己根据栏目目录拼接
        } else {
          // console.log(`/${parentUrl}/${item.name}`);
          this.$router.push(`/${item.name}`)
        }
      },
      // 根据不同子菜单name值去跳到不同的路由
      navClick(parentUrl, item) {
        // 如果此栏目属于跳转栏目的话就使用url作为跳转链接
        if (item.sectionType === "REDIRECT" && item.url !== null) {
          var reg=/(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/;
          // 如果不是一个网址 就正常跳转路由
          if (!reg.test(item.url)) {
            this.$router.push(`/${parentUrl}/${item.url}`)
            // 如果是一个网址 就跳转这个网址
          } else {
            window.location.href = item.url
          }
          // 如果此栏目不属于的话就自己根据栏目目录拼接
        } else {
          // console.log(`/${parentUrl}/${item.name}`);
          this.$router.push(`/${parentUrl}/${item.name}`)
        }
      },
      checkClick(parentUrl, item) {
        this.$router.push({path: `/web_plus/`+ `${item.id}`}) 
      },
      getSiteList() {
        myPost('/home/site/all')
        .then(res=>{
          this.siteList = [...res.data.data]
          if(localStorage.getExpire('siteId')) {
            this.$store.commit("changeSiteForm", {
              id: localStorage.getExpire('siteId'), 
              name: ""
          })
            this.siteShow = true
          }
          else {
            this.$store.commit("changeSiteForm", {
              id: this.siteList[0].id, 
              name: ""
            })
            // localStorage.setExpire('siteId', this.$store.state.siteForm.id)
            this.siteShow = true
          }
          this.siteList.forEach(e=>{
            if(e.id === this.$store.state.siteForm.id) {
              var oldId = this.$store.state.siteForm.id
              this.$store.commit("changeSiteForm", {
                id: oldId, 
                name: e.name
              })
            }
          })
          // console.log(this.siteList);
          // console.log(this.$store.state.siteForm);
        })
      },
      loginSite() {
        var loginItem={id: "68499e58090d4aafa0fb6d0545d4f2c1",
                       name: "总站"}
        this.chooseSite(loginItem)
      },
      chooseSite(item) {
        // localStorage.setExpire('siteId',item.id)
         this.$store.commit("changeSiteForm", {
              id: item.id, 
              name: item.name
          })
        // this.siteForm.id = this.$store.state.siteForm.id
        // this.siteForm.name = this.$store.state.siteForm.name
        this.siteListShow = false
        // this.$store.state.siteForm.id
        myGet('/application/basicInfo/' + this.$store.state.siteForm.id)
        .then(res => {
          // console.log(res.data.data)
          this.homeData = res.data.data
          document.title = this.homeData.name
          document.querySelector('meta[name="keywords"]').setAttribute('content', this.homeData.keywords)
          document.querySelector('meta[name="description"]').setAttribute('content', this.homeData.description)
          document.querySelector('link').setAttribute('href', this.homeData.faviconLogo)
          this.$store.commit("changeKeyWords", this.homeData.keywords)
          this.$store.commit("changeDescription", this.homeData.description) 
          this.$store.commit("changeName", this.homeData.name)
          // console.log(this.$store.state.keywords)
          // console.log(this.$store.state.description)
        })
        // localStorage.setExpire('siteId',item.id)
        this.$store.commit("changeSiteForm", {
          id: item.id, 
          name: item.name
        })
        // console.log(item)
        // console.log(item.id, item.name, 3333333333333333);
        // console.log(this.$store.state.siteForm);
        this.$store.commit("changeSiteListShow", false)
      },
      over0() {
        this.$store.commit('changeDisplayFlag', 'inline')
        this.$store.commit('changeNavFlag', true)
      },
      out0() {
        this.$store.commit('changeDisplayFlag', 'none')
        this.$store.commit('changeNavFlag', false)
      },
      testtest() {
        // console.log(123123123);
      }
    }
  }
</script>

<style scoped>
    .site_list_container {
      position: absolute;
      /* background-color: #fff; */
      background-color: red;
      color:white;
      box-shadow: 1px 1px 2px #0e0000;
      padding: 10px 35px;
      top: 90px;
      left: 205px;
      z-index: 999;
      text-align: center;
    }
    @media only screen and (max-width: 1500px) {
      .site_list_container {
        left: 193px !important;
      }
    }
    .site_list_container li{
      padding-right: 0px;
      line-height: 35px;
      cursor: pointer;
    }
    .site_list_container li:nth-child(4n) {
      padding-right: 0;
    }
    .el-header {
      padding: 0;
      width: 100%;
      /* box-sizing: border-box; */
    }
    .el-main {
      /* background-color: #F5F5F5; */
      color: #333;
      width: 100%;
      min-width: 1300px;
      height: 100%;
      text-align: left;
      padding: 0;
    }
    .el-footer {
      width: 100%;
      /* text-align: center;
      line-height: 40px;
      background-color: #fff; */
    }
    .el-container {
      width: 100%;
      height: 100%;
    }
    .el-aside {
      height: 100%;
    }
    .spinner {
      /* display: none; */
      position: relative;
      width: 100%;
      height: 110px;
      line-height: 100px;
      background-color: #D10F0F;
      /* display: flex;
      justify-content: space-around; */
      /* vertical-align: middle; */
      z-index: 9999;
      box-sizing: content-box;
    }
    .imgContain {
      float: left;
      width: 95px;
      height: 110px;
      line-height: 110px;
      text-align: center;
      cursor: pointer;
    }
    .imgContain .imgChildContainer {
      width: 95px;
      height: 60px;
    }
    .imgContain img {
      margin-top: 15px;
      width: 41px;
      height: 41px;
      box-sizing: border-box;
    }
    .imgContain .textContent {
      margin-top: 10px;
      width: 95px;
      height: 20px;
      line-height: 20px;
      color: #fff;
      font-size: 14px;
      /* margin-bottom: 10px; */
    }
</style>










<style scoped>
  .navmenu-container {
    background-color: #fff;
    height: 100%;
    overflow-y: hidden;
    overflow-x: auto;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    /* border-bottom: 1px solid yellow; */
  }
  .head-list {
    display: flex;
    justify-content: center;
    align-items: center;
    /* height: 90px; */
  }
  .head-list img {
    padding: 0 20px;
    border-left: 1px solid #F0F0F0;
  }
  .head-list span {
    font-size: 20px;
    font-weight: 600;
    color: #D7262E;
    padding: 0 15px;
    width: 145px;
    border-left: 1px solid #F0F0F0;
  }
  .navmenu-container .el-dialog__header {
    display: none;
  }
  .navmenu-container .el-dialog__body {
    padding: 0;
  }
  .navmenu-container .el-input__inner {
    height: 50px;
    line-height: 50px;
  }
  .navmenu-container .el-button--danger {
    color: #fff;
    background-color: #D7262E;
    border-color: #D7262E;
  }
  .navmenu-container .el-button--danger,.navmenu-container .el-button {
    width: 130px;
    height: 50px;
  }
  .navmenu-container .el-input-group__append {
    color: #fff;
    background-color: #D7262E;
  }
</style>




// WEBPACK FOOTER //
// src/components/main/main.vue